import {setText} from '@acng/frontend-bounty';
import {URLSearchParams} from '@acng/frontend-bounty/net/url.js';
import {fetch} from '@acng/frontend-bounty/net/fetch.js';
import {add} from '@acng/frontend-bounty/style/element.js';
import {query} from '@acng/frontend-bounty/dom/query.js';
import {INTEGER, MINMAX, guard} from '@acng/frontend-rubicon';

import {handleCfChallenge} from '../../core/service/backend/cf-challenge.js';
import {user} from '../../user/user.js';
import {STYLE_EMPTY, swapClass} from '../../layout/service/style.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

/**
 * @param {'movie' | 'picture'} type
 */
export const SetGalleryCount =
  (type) =>
  /**
   * @param {Element} element
   * @param {Amateur | null} amateur
   *
   * @returns {Promise<void>}
   */
  async (element, amateur) => {
    add(element, STYLE_EMPTY);
    DEBUG: if (debug(element)) console.info(name, {element, amateur});

    if (!amateur) {
      return;
    }

    const params = new URLSearchParams({
      limit: '0',
      offset: '0',
      fsk: `${user.getListFsk()}`,
      filter: JSON.stringify({nickname: amateur.nickname}),
    });

    const response = await fetch(`/api/${type}/lists?${params}`);

    handleCfChallenge(response);

    if (!response.ok) {
      throw response;
    }
    const {total} = await response.json();
    ASSERT: guard(total, GALLERY_COUNT, 'amateur gallery count from ACNG backend');

    const valueNode = query(element, '.value') ?? element;
    setText(valueNode, `${total}`);
    swapClass(element, STYLE_EMPTY, !total);
  };

const GALLERY_COUNT = /* @__PURE__ */ MINMAX(0, 5000, INTEGER);
